import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { validaCpfCnpj } from 'utils/validation';
import { labelsCaracteristicas } from './labels';
import { GrupoAcesso, FuncaoParticipante } from 'common/genericTypes';

export enum EtapaCadastro {
  Caracteristicas = 'Caracteristicas',
  CriteriosRemuneracao = 'CriteriosRemuneracao',
  EventosFinanceiros = 'EventosFinanceiros',
  Documentos = 'Documentos',
}

type labelsType = typeof labelsCaracteristicas;

export function useValidarCampos(label: labelsType): boolean;
export function useValidarCampos(etapa?: EtapaCadastro): Array<string>;

export function useValidarCampos(arg?: EtapaCadastro | labelsType): Array<string> | boolean {
  const caracteristicas = useSelector((state: RootState) => state.cotasDeFundoCadastro.caracteristicas);
  const uploadDocumentos = useSelector((state: RootState) => state.cotasDeFundoCadastro.uploadDocumentos);
  const grupoAcesso = useSelector((state: RootState) => state.auth.usuario.grupoAcesso);
  const isUsuarioCadastroOuOperacoes =
    grupoAcesso === GrupoAcesso.CadastroOperacoes || grupoAcesso === GrupoAcesso.Operacoes;
  const isParticipanteCustodiante = useSelector(
    (state: RootState) => state.auth.usuario.participante.funcao === FuncaoParticipante.Custodiante
  );

  let camposInvalidosCE: Array<string> = [];

  if (!caracteristicas.cnpjFundo || !validaCpfCnpj(caracteristicas.cnpjFundo))
    camposInvalidosCE.push(labelsCaracteristicas.cnpjFundo);

  if (!caracteristicas.numeroEmissao)
    camposInvalidosCE.push(labelsCaracteristicas.numeroEmissao);

  if (!caracteristicas.administradorFiduciarioId)
    camposInvalidosCE.push(labelsCaracteristicas.administradorFiduciario);

  if (!caracteristicas.nomeFantasia)
    camposInvalidosCE.push(labelsCaracteristicas.nomeFantasia);

  if (!caracteristicas.gestor)
    camposInvalidosCE.push(labelsCaracteristicas.gestor);

  if (!caracteristicas.escrituradorId)
    camposInvalidosCE.push(labelsCaracteristicas.escriturador);

  if (!caracteristicas.custodianteId)
    camposInvalidosCE.push(labelsCaracteristicas.custodiante);

  if (!caracteristicas.codigoAtivo)
    camposInvalidosCE.push(labelsCaracteristicas.codigoAtivo);

  if (!caracteristicas.classe)
    camposInvalidosCE.push(labelsCaracteristicas.classe);

  if (!caracteristicas.serie)
    camposInvalidosCE.push(labelsCaracteristicas.serie);

  if (!caracteristicas.classificacaoANBIMA)
    camposInvalidosCE.push(labelsCaracteristicas.classificacaoANBIMA);

  if (caracteristicas.fundoExclusivo === undefined)
    camposInvalidosCE.push(labelsCaracteristicas.fundoExclusivo);

  if (!caracteristicas.tipoFundo)
    camposInvalidosCE.push(labelsCaracteristicas.tipoFundo);

  if (caracteristicas.casasDecimaisConversao === undefined)
    camposInvalidosCE.push(labelsCaracteristicas.casasDecimaisConversao);

  if (!caracteristicas.criterioEspecificacaoCotas)
    camposInvalidosCE.push(labelsCaracteristicas.criterioEspecificacaoCotas);

  if (caracteristicas.especificacaoQuantidadeAutomatica === undefined)
    camposInvalidosCE.push(labelsCaracteristicas.especificacaoQuantidadeAutomatica);

  if (caracteristicas.prazoCotacaoAplicacao === undefined)
    camposInvalidosCE.push(labelsCaracteristicas.prazoCotacaoAplicacao);

  if (caracteristicas.prazoCotacaoResgate === undefined)
    camposInvalidosCE.push(labelsCaracteristicas.prazoCotacaoResgate);

  if (caracteristicas.prazoLiquidacaoResgate === undefined)
    camposInvalidosCE.push(labelsCaracteristicas.prazoLiquidacaoResgate);

  try {
    const docs = uploadDocumentos?.documents ?? [];
    const hasAtLeastOne = docs.some((d) => Boolean((d as any)?.file) || Boolean((d as any)?.remoteFileInfo));
    if (!hasAtLeastOne) {
      camposInvalidosCE.push(labelsCaracteristicas.documentos);
    }
  } catch {}

  if (arg === EtapaCadastro.Caracteristicas) return camposInvalidosCE;

  const camposInvalidos = camposInvalidosCE;
  
  return typeof arg === 'string' ? camposInvalidos.includes(arg) : camposInvalidos;
}
